import { CARRIER_SERVICES_ACTIONS, initialCarrierServicesState } from './carrierServices.types'

/**
 * @param {import('./carrierServices.types').CarrierServicesSlice} state
 * @param {Object} action
 */
export function carrierServicesReducer(state = initialCarrierServicesState, { type, payload }) {
  switch (type) {
    case CARRIER_SERVICES_ACTIONS.SET_CARRIER_SERVICES:
      return { ...state, data: payload }

    case CARRIER_SERVICES_ACTIONS.SET_CARRIER_SERVICE:
      return {
        ...state,
        data: [...state.data.filter(service => service.id !== payload.id), payload]
      }

    case CARRIER_SERVICES_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case CARRIER_SERVICES_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CARRIER_SERVICES_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    case CARRIER_SERVICES_ACTIONS.CLEAR_CARRIER_SERVICES:
      return { ...state, data: [] }

    default:
      return state
  }
}
